import { useState } from "react";
import { reviewsAPI } from "../features/reviews/reviewsAPI";

export const useReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalReviews, setTotalReviews] = useState(0);
  // Thêm state cho phân trang
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchReviews = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.getReviews(params);

      if (result.success) {
        setReviews(result.data.reviews || []);
        setTotalReviews(result.data.total || 0);
        // Cập nhật pagination data
        setCurrentPage(parseInt(result.data.currentPage) || 1);
        setTotalPages(result.data.totalPages || 1);
        return {
          reviews: result.data.reviews || [],
          total: result.data.total || 0,
          currentPage: result.data.currentPage || 1,
          totalPages: result.data.totalPages || 1,
          success: true,
        };
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getReview = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.getReview(id);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const createReview = async (reviewData) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.createReview(reviewData);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const deleteReview = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.deleteReview(id);

      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const checkUserReview = async (schoolId) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.checkUserReview(schoolId);

      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const markHelpful = async (id, helpful) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.markHelpful(id, helpful);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getMyVote = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.getMyVote(id);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    reviews,
    setReviews,
    totalReviews,
    loading,
    error,
    // Thêm pagination states
    currentPage,
    totalPages,
    setCurrentPage,
    fetchReviews,
    getReview,
    createReview,
    deleteReview,
    checkUserReview,
    markHelpful,
    getMyVote,
  };
};
